module.exports = __webpack_public_path__ + "static/img/waiting_setting.eda9df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/waiting_setting.png
// module id = bmCo
// module chunks = 134